import { type ReferentialEnum, labelOf } from "@pharmupp/p3-front-commons"

// Define the columns used in the CsvUpsert CSV import. The order of columns matters.
export const usersCsvUpsertColumns = [
  "email",
  "phone",
  "title",
  "lastName",
  "firstName",
  "birthName",
  "birthDate",
  "rppsId",
  "type",
  "function",
] as const

export type UsersCsvUpsertColumnName = (typeof usersCsvUpsertColumns)[number]

const usersCsvUpsertColumnsEnum = {
  email: { label: "Adresse e-mail" },
  phone: { label: "Numéro de téléphone" },
  title: { label: "Civilité" },
  firstName: { label: "Prénom" },
  lastName: { label: "Nom de famille" },
  birthName: { label: "Nom de naissance" },
  birthDate: { label: "Date de naissance" },
  rppsId: { label: "Numéro RPPS" },
  type: { label: "Rôle" },
  function: { label: "Fonction" },
} satisfies Record<UsersCsvUpsertColumnName, unknown> & ReferentialEnum

export const usersCsvUpsertLabels = usersCsvUpsertColumns.map((key) =>
  labelOf(usersCsvUpsertColumnsEnum, key),
)
